import { isAgentGridClaimFlow, isAgentGridSource } from '@/utils/authBrand';

/**
 * AuthBrandMixin
 *
 * Shared branding state for the auth views (Login, Signup, ForgotPassword, ResetPassword)
 * and the auth components they render. Auth flows started from Agent Grid get the Agent Grid
 * light theme; everything else keeps Anima's dark theme.
 *
 * Views must not declare a `theme` data property — it is provided here as a computed.
 */
export default {
  computed: {
    isAgentGridAuth() {
      return isAgentGridSource(this.$route?.query);
    },
    // Agent Grid's claim flow, whose step 1 this sign-in is.
    isAgentGridClaimFlow() {
      return isAgentGridClaimFlow(this.$route?.query);
    },
    authBrandClass() {
      return this.isAgentGridAuth ? 'auth-brand-agentgrid' : 'auth-brand-anima';
    },
    // Colour scheme passed to an-input / an-checkbox.
    theme() {
      return this.isAgentGridAuth ? 'light' : 'dark';
    },
    authThemeVariant() {
      return this.isAgentGridAuth ? 'agentgrid' : 'onboarding';
    },
    authLoaderColor() {
      return this.isAgentGridAuth ? 'var(--agentgrid-text-primary)' : 'var(--purple)';
    }
  },
  methods: {
    applyAuthTheme() {
      this.applyTheme(this.theme, this.authThemeVariant);
    }
  }
};
